/**
 * Trade quantity rule validation. Reads min/max/multiple/message from
 * data-tqr-* attributes on a quantity input and validates a candidate qty.
 *
 * Exposed as window.TradeQuantity.
 */
(function () {
  function readRule(input) {
    if (!input || !input.dataset) return null;
    var min = parseInt(input.dataset.tqrMin, 10);
    var multiple = parseInt(input.dataset.tqrMultiple, 10);
    var max = input.dataset.tqrMax ? parseInt(input.dataset.tqrMax, 10) : null;
    var message = input.dataset.tqrMessage || '';

    if (isNaN(min) || min < 1) min = 1;
    if (isNaN(multiple) || multiple < 1) multiple = 1;
    if (max !== null && isNaN(max)) max = null;

    return { min: min, multiple: multiple, max: max, message: message };
  }

  function validate(qty, rule) {
    qty = parseInt(qty, 10);
    if (isNaN(qty)) qty = rule.min;
    var corrected = qty;
    var ok = true;
    var reason = '';

    if (corrected < rule.min) {
      corrected = rule.min;
      ok = false;
      reason = rule.message || ('Minimum quantity is ' + rule.min + '.');
    }
    if (rule.max !== null && corrected > rule.max) {
      corrected = rule.max;
      ok = false;
      reason = rule.message || ('Maximum quantity is ' + rule.max + '.');
    }
    var offset = corrected - rule.min;
    if (rule.multiple > 1 && offset % rule.multiple !== 0) {
      var rem = offset % rule.multiple;
      corrected = corrected - rem + rule.multiple;
      if (rule.max !== null && corrected > rule.max) {
        corrected = corrected - rule.multiple;
      }
      if (corrected < rule.min) corrected = rule.min;
      ok = false;
      reason = rule.message || ('Quantity must be in multiples of ' + rule.multiple + '.');
    }

    return { ok: ok, corrected: corrected, reason: reason };
  }

  function validateInput(input) {
    var rule = readRule(input);
    if (!rule) return { ok: true, corrected: parseInt(input.value, 10) || 1, reason: '' };
    return validate(input.value, rule);
  }

  window.TradeQuantity = {
    readRule: readRule,
    validate: validate,
    validateInput: validateInput
  };
})();
